import { Component, inject, input, OnInit, signal } from '@angular/core';
import { ISidebarNavItem } from '../sidebar/sidebar.interface';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IconSvg } from '../icon-svg/icon-svg';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';

@Component({
  selector: 'app-nav-sidebar',
  imports: [RouterLink, RouterLinkActive, IconSvg, BadgeModule, OverlayBadgeModule],
  templateUrl: './nav-sidebar.html',
  styleUrl: './nav-sidebar.css',
})
export class NavSidebar{
  item = input.required<ISidebarNavItem>();
  disabled = input<boolean>(true);
  isHovered = signal(false);
  notificationsNbr = input<number>(0);
}
